import { createSelector } from "reselect";
import { ROLES_RAW } from "../../constants/permissions";

export const isUserAuthorized = (state) => state.authorization;
export const getCurrentTheme = (state) => state.currentTheme;
export const getNotificationsState = (state) => state.notifications;

export const getUserProfile = (state) => state.profile;
export const getCurrentUserRole = createSelector(getUserProfile, (profile) => (profile && ROLES_RAW.includes(profile.role) ? profile.role : null));

export const getUsers = (state) => state.users;
export const getUsersForm = (state) => state.usersForm;

export const getAlerts = (state) => state.alerts;

export const getApplications = (state) => state.applications;
export const getApplicationsForm = (state) => state.applicationsForm;

export const getTickets = (state) => state.tickets;
export const getTicketsForm = (state) => state.ticketsForm;
